import * as Reflect from "../reflect-metadata";

(<any>window).Reflect = Reflect;

export * from "../reflect-metadata";



/** WEBPACK FOOTER **
 ** ./src/global/browser.ts
 **/